import { Pipe, PipeTransform } from '@angular/core';
import { ConvertBlankDate } from '../../../core';


@Pipe({
  name: 'dateBlank'
})
export class DateBlankPipe implements PipeTransform {

  transform(value: any, formatStr?: string, dfault?:string): string {
    try {
      if(typeof(value) == 'string')
        value = Date.parse(value);
      if(formatStr ){
        return ConvertBlankDate(value, formatStr, dfault);
      }
      return ConvertBlankDate(value);

    } catch (error) {
      //debugger;
    }
    return " ";
  }

}
